import { setCompletedPagePayload } from '../../../types/Navigation/SetCompletedPagePayload';
import { deepEqual } from '../../../utilities/deepEqual';
import { updateNavigationObject } from './updateNavigationObject';

export const setCompletedPage = async (payload: setCompletedPagePayload) => {
  const navObjClone = structuredClone(payload.patientInfo.navObj);

  // SET THE PAGE COMPLETION STATUS
  navObjClone[payload.name].completed = payload.value;

  // CHECK IF THE NAVIGATION OBJECT HAS CHANGED. IF NOT, RETURN.
  if (deepEqual(navObjClone, payload.patientInfo.navObj)) {
    return;
  } else {
    // UPDATE THE NAVIGATION OBJECT IN FIRESTORE
    const updateNavPayload = {
      uid: payload.patientInfo.uid,
      navObj: navObjClone,
      source: 'setCompletedPage',
    };
    return await updateNavigationObject(updateNavPayload);
  }
};
